// DOCS:
// https://ionicframework.com/docs/angular/slides
// https://swiperjs.com/element

import { CommonModule } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  input,
  output,
  QueryList,
  TemplateRef,
  viewChild,
} from '@angular/core'
import { IonicSlides } from '@ionic/angular'
import { SwiperContainer } from 'swiper/element'
import { Swiper } from 'swiper/types'
import { SlideEventDetail, SlidesOptions } from './slides.cnst'

@Component({
  selector: 'app-slides',
  imports: [CommonModule],
  templateUrl: 'slides.component.html',
  styleUrl: 'slides.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SlidesComponent implements AfterViewInit {
  protected config = input<SlidesOptions>()

  protected slideChanged = output<SlideEventDetail>()
  protected touchEnded = output<SlideEventDetail>()
  protected transitionStarted = output<SlideEventDetail>()
  protected transitionEnded = output<SlideEventDetail>()
  protected reachEnd = output<SlideEventDetail>()
  protected reachBeginning = output<SlideEventDetail>()
  protected snapIndexChange = output<SlideEventDetail>()

  protected swiperModules = [IonicSlides]
  protected swiperContainer = viewChild.required<ElementRef<SwiperContainer>>('container')

  @ContentChildren('slideItem')
  protected swiperSlides?: QueryList<TemplateRef<any>>

  public ngAfterViewInit(): void {
    const swiperParams: SlidesOptions = {
      shortSwipes: false,
      longSwipesRatio: 0.1,
      longSwipesMs: 50,
      ...this.config(),
    }

    // assign all config parameters to the Swiper element
    Object.assign(this.swiperContainer().nativeElement, swiperParams)

    this.swiperContainer().nativeElement.initialize()
  }

  public slideTo(index: number, speed?: number, runCallbacks?: boolean): void {
    this.swiper.slideTo(index, speed, runCallbacks)
  }

  public slideNext(speed?: number, runCallbacks?: boolean): void {
    this.swiper.slideNext(speed, runCallbacks)
  }

  public slidePrev(speed?: number, runCallbacks?: boolean): void {
    this.swiper.slidePrev(speed, runCallbacks)
  }

  public get swiper(): Swiper {
    return this.swiperContainer().nativeElement.swiper
  }

  public get activeIndex(): number {
    return this.swiper.activeIndex
  }
}
